import React from 'react';

interface WarningIconProps {
    width?: number | string;
    height?: number | string;
    fill?: string;
    stroke?: string;
}

export const WarningIcon: React.FC<WarningIconProps> = ({
    width = 45,
    height = 45,
    fill = 'white',
    stroke = 'none',
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 45 45"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M24.1074 32.1431C24.1074 32.5693 23.938 32.9781 23.6366 33.2795C23.3352 33.5809 22.9265 33.7502 22.5002 33.7502C22.074 33.7502 21.6652 33.5809 21.3638 33.2795C21.0624 32.9781 20.8931 32.5693 20.8931 32.1431C20.8931 31.7168 21.0624 31.3081 21.3638 31.0067C21.6652 30.7053 22.074 30.5359 22.5002 30.5359C22.9265 30.5359 23.3352 30.7053 23.6366 31.0067C23.938 31.3081 24.1074 31.7168 24.1074 32.1431ZM21.2949 26.9199C21.2949 27.2395 21.4219 27.5461 21.6479 27.7722C21.874 27.9982 22.1805 28.1252 22.5002 28.1252C22.8199 28.1252 23.1265 27.9982 23.3525 27.7722C23.5786 27.5461 23.7056 27.2395 23.7056 26.9199V16.4734C23.7056 16.1538 23.5786 15.8472 23.3525 15.6211C23.1265 15.3951 22.8199 15.2681 22.5002 15.2681C22.1805 15.2681 21.874 15.3951 21.6479 15.6211C21.4219 15.8472 21.2949 16.1538 21.2949 16.4734V26.9199ZM18.6302 6.70201C20.3113 3.65808 24.6892 3.65647 26.3702 6.70201L41.2363 33.6216C42.8627 36.5675 40.7317 40.1788 37.3679 40.1788H7.6454C4.28165 40.1788 2.14897 36.5691 3.7754 33.6233L18.6302 6.70201ZM24.2584 7.86718C24.0848 7.55299 23.8301 7.29108 23.5209 7.10869C23.2117 6.9263 22.8592 6.8301 22.5002 6.8301C22.1412 6.8301 21.7888 6.9263 21.4796 7.10869C21.1704 7.29108 20.9157 7.55299 20.742 7.86718L5.88558 34.7884C5.71673 35.0944 5.6306 35.4391 5.6357 35.7885C5.6408 36.1379 5.73695 36.4799 5.91465 36.7808C6.09236 37.0817 6.34547 37.331 6.649 37.5041C6.95252 37.6773 7.29596 37.7682 7.6454 37.7681H37.3663C37.7156 37.768 38.0588 37.6768 38.3621 37.5035C38.6654 37.3303 38.9183 37.0809 39.0958 36.7801C39.2734 36.4792 39.3694 36.1373 39.3744 35.7881C39.3794 35.4388 39.2933 35.0943 39.1245 34.7884L24.2584 7.86718Z"
                fill={fill}
                stroke={stroke}
            />
        </svg>
    );
};
